import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardFinancialComponent } from "./dashboard-financial/dashboard-financial.component";
import { DashboardSorttimeCompaniesComponent } from "./dashboard-sorttime-companies/dashboard-sorttime-companies.component";
import { AccountComponent } from "./account/account.component";
import { UsersComponent } from "./users/users.component";
import { CompaniesComponent } from "./companies/companies.component";
import { VenuesComponent } from "./venues/venues.component";
import { DepartmentsComponent } from "./departments/departments.component";
import { EmployeePositionsComponent } from "./employee-positions/employee-positions.component";
import { EmployeesComponent } from "./employees/employees.component";
import { RolesComponent } from "./roles/roles.component";
import { PermissionsComponent } from "./permissions/permissions.component";
import { CustomerGuidesComponent } from "./customer-guides/customer-guides.component";
import { CustomerGuidesSynergoComponent } from "./customer-guides-synergo/customer-guides-synergo.component";
import { StationsComponent } from "./stations/stations.component";
import { ManagementClaroComponent } from "./management-claro/management-claro.component";
import { OpeningsStationsComponent } from "./opening-stations/openings-stations.component";
import { MinutesComponent } from "./minutes/minutes.component";
import { CitationsComponent } from "./citations/citations.component";
import { RecruitmentsComponent } from "./recruitment/recruitments.component";
import { RecruitmentsByRequisitionComponent } from "./recruitment/recruitments-by-requisition/recruitments-by-requisition.component";
import { ProfileSurveisComponent } from "./profile-surveis/profile-surveis.component";
import { NewProfileSurveyComponent } from "./profile-surveis/new-profile-survey/new-profile-survey.component";
import { ListDocumentProfileSurveisComponent } from "./list-document-profile-surveis/list-document-profile-surveis.component";
import { DocumentProfileSurveysComponent } from "./document-profile-surveys/document-profile-surveys.component";
import { RequisitionsComponent } from "./requisitions/requisitions.component";
import { NewRequisitionComponent } from "./requisitions/new-requisition/new-requisition.component";
import { CandidatesComponent } from "./candidates/candidates.component";
import { CandidatesSynergoComponent } from "./candidates-synergo/candidates-synergo.component";
import { CandidateCommentsComponent } from "./candidate-comments/candidate-comments.component";
import { EducationsComponent } from "./educations/educations.component";
import { WorkExperiencesComponent } from "./work-experiences/work-experiences.component";
import { PqrsComponent } from "./pqrs/pqrs.component";
import { PqrTypificationsComponent } from "./pqr-typifications/pqr-typifications.component";
import { DevelopmentRequestsComponent } from "./development-requests/development-requests.component";
import { NewDevelopmentRequestsComponent } from "./development-requests/new-development-requests/new-development-requests.component";
import { BanksComponent } from "./banks/banks.component";
import { BankBooksComponent } from "./bank-books/bank-books.component";
import { RadicationsSSComponent } from "./radication-ss/radications-ss.component";
import { FindingsComponent } from "./findings/findings.component";
import { ArchivesComponent } from "./archives/archives.component";
// import { RequisitionTasksComponent } from './requisition-tasks/requisition-tasks.component';
import { FolderSharesComponent } from "./folder-shares/folder-shares.component";
import { DirectorysComponent } from "./directorys/directorys.component";
import { WorkerCaresComponent } from "./worker-care/worker-cares.component";
import { GestionSACsComponent } from "./gestionSACs/gestionSACs.component";
import { NewGestionSACComponent } from "./gestionSACs/new-gestionSAC/new-gestionSAC.component";
// import { DailyVisitsComponent } from './daily-visits/daily-visits.component';
import { ContractsComponent } from "./contracts/contracts.component";
import { NewContractComponent } from "./contracts/new-contract/new-contract.component";
import { TipsComponent } from "./tips/tips.component";
import { RoutesComponent } from "./routes/routes.component";
import { InspectionsComponent } from "./inspections/inspections.component";
import { InspectionEquipmentsComponent } from "./inspection-equipments/inspection-equipments.component";
import { TheftsComponent } from "./thefts/thefts.component";
import { ScheduleEmployeesComponent } from "./schedule-employees/schedule-employees.component";
import { ExpiredDocumentsComponent } from "./expired-documents/expired-documents.component";
import { AccountEditComponentComponent } from "./account/account-edit-component/account-edit-component.component";
import { EmployeeEditComponentComponent } from "./account/employee-edit-component/employee-edit-component.component";
import { SynergoCitationsComponent } from "./synergo/synergo-citations/synergo-citations.component";
import { SynergoRequisitionsComponent } from "./synergo/synergo-requisitions/synergo-requisitions.component";
import { NewCandidateComponent } from "./candidates/new-candidate/new-candidate.component";
import { NewCandidateSynergoComponent } from "./candidates-synergo/new-candidate-synergo/new-candidate-synergo.component";
import { AuthLoginGuard } from "../service/auth-guard-login/auth-login.guard";
import { NewCustomerGuideComponent } from "./customer-guides/new-customer-guide/new-customer-guide.component";
import { NewCustomerGuideSynergoComponent } from "./customer-guides-synergo/new-customer-guide-synergo/new-customer-guide-synergo.component";
import { SystemsInventoryRequestsComponent } from "./systems-inventory-requests/systems-inventory-requests.component";
import { NewSystemsInventoryRequestComponent } from "./systems-inventory-requests/new-systems-inventory-request/new-systems-inventory-request.component";
import { SystemsRequestsComponent } from "./systems-requests/systems-requests.component";
import { NewSystemRequestComponent } from "./systems-requests/new-system-request/new-system-request.component";
import { VacationsComponent } from "./vacations/vacations.component";
import { NewVacationComponent } from "./vacations/new-vacation/new-vacation.component";
import { EmployeeVirtualOfficeComponent } from "./employee-virtual-office/employee-virtual-office.component";
import { MedicalCasesComponent } from "./medical-cases/medical-cases.component";
import { NewMedicalCaseComponent } from "./medical-cases/new-medical-case/new-medical-case.component";
import { MedicalCasesEventComponent } from "./medical-cases/medical-cases-event/medical-cases-event.component";
import { CandidateDisabilitiesAdminComponent } from "../../disability/components/candidate-disabilities-admin/candidate-disabilities-admin/candidate-disabilities-admin.component";
import { NewCandidateDisabilitiesAdminComponent } from "../../disability/components/candidate-disabilities-admin/candidate-disabilities-admin/new-candidate-disabilities-admin/new-candidate-disabilities-admin.component";
import { ValidMedicalExamsComponent } from "./medical-exams/valid-medical-exams/valid-medical-exams.component";
const routes: Routes = [
  {
    path: "pages",
    component: PagesComponent,
    canActivate: [AuthLoginGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "dashboard", component: DashboardComponent },

      {
        path: "reports/financial-dashboard",
        component: DashboardFinancialComponent,
      },
      {
        path: "reports/sorttime-companies-dashboard",
        component: DashboardSorttimeCompaniesComponent,
      },

      { path: "account", component: AccountComponent },
      { path: "account/edit/user", component: AccountEditComponentComponent },
      {
        path: "account/edit/employee",
        component: EmployeeEditComponentComponent,
      },
      { path: "directorys", component: DirectorysComponent },
      { path: "vacations", component: VacationsComponent },
      { path: "vacations/:id", component: NewVacationComponent },

      { path: "pqrs", component: PqrsComponent },
      { path: "pqrs/pqrs_verification", component: PqrsComponent },
      { path: "pqrs/pqrs_reported", component: PqrsComponent },
      { path: "pqrs/pqrs_asigned", component: PqrsComponent },
      { path: "pqrs/pqrs_typification", component: PqrTypificationsComponent },

      {
        path: "innovation/development-requests",
        component: DevelopmentRequestsComponent,
      },
      {
        path: "innovation/development-requests/:id",
        component: NewDevelopmentRequestsComponent,
      },

      { path: "medical-cases", component: MedicalCasesComponent },
      {
        path: "medical-cases/:medical_case_id",
        component: NewMedicalCaseComponent,
      },
      {
        path: "medical-cases/events/:candidate_id",
        component: MedicalCasesEventComponent,
      },
      {
        path: "medical-cases/events/:candidate_id/:event_id",
        component: NewMedicalCaseComponent,
      },
      {
        path: "valid-medical-exams/:id",
        component: ValidMedicalExamsComponent,
      },

      { path: "disabilities", component: CandidateDisabilitiesAdminComponent },
      {
        path: "disabilities/:id",
        component: NewCandidateDisabilitiesAdminComponent,
      },

      {
        path: "innovation/systems-inventory-requests",
        component: SystemsInventoryRequestsComponent,
      },
      {
        path: "innovation/systems-inventory-requests/:id",
        component: NewSystemsInventoryRequestComponent,
      },

      {
        path: "innovation/systems-requests",
        component: SystemsRequestsComponent,
      },
      {
        path: "innovation/systems-requests/:id",
        component: NewSystemRequestComponent,
      },

      { path: "virtual-office", component: EmployeeVirtualOfficeComponent },

      { path: "management-claro/stations", component: StationsComponent },
      { path: "management-claro/auxiliar", component: EmployeesComponent },
      { path: "management-claro/manager", component: EmployeesComponent },
      {
        path: "management-claro/openings-stations",
        component: OpeningsStationsComponent,
      },
      { path: "management-claro/minutes", component: MinutesComponent },
      {
        path: "management-claro/management-claro",
        component: ManagementClaroComponent,
      },
      { path: "management-claro/routes", component: RoutesComponent },
      { path: "management-claro/inspections", component: InspectionsComponent },
      {
        path: "management-claro/inspection-equipments",
        component: InspectionEquipmentsComponent,
      },
      { path: "management-claro/thefts", component: TheftsComponent },

      { path: "schedule-employees", component: ScheduleEmployeesComponent },

      { path: "administration/users", component: UsersComponent },
      { path: "administration/companies", component: CompaniesComponent },
      { path: "administration/venues", component: VenuesComponent },
      { path: "administration/departments", component: DepartmentsComponent },
      {
        path: "administration/employee-positions",
        component: EmployeePositionsComponent,
      },
      { path: "administration/employees", component: EmployeesComponent },
      { path: "administration/roles", component: RolesComponent },
      { path: "administration/permissions", component: PermissionsComponent },

      { path: "customer-guides", component: CustomerGuidesComponent },
      {
        path: "customer-guides/:customer_guide_id",
        component: NewCustomerGuideComponent,
      },
      {
        path: "customer-guides-synergo",
        component: CustomerGuidesSynergoComponent,
      },
      {
        path: "customer-guides-synergo/:customer_guide_id",
        component: NewCustomerGuideSynergoComponent,
      },
      { path: "profile-surveis", component: ProfileSurveisComponent },
      { path: "profile-survey", component: NewProfileSurveyComponent },

      { path: "selection/citations", component: CitationsComponent },
      { path: "selection/recruitments", component: RecruitmentsComponent },
      {
        path: "selection/recruitments/:id",
        component: RecruitmentsByRequisitionComponent,
      },
      { path: "selection/requisitions", component: RequisitionsComponent },
      {
        path: "selection/requisitions/:requisition_id",
        component: NewRequisitionComponent,
      },
      { path: "selection/documental-analyst", component: EmployeesComponent },
      { path: "selection/candidates", component: CandidatesComponent },
      {
        path: "selection/candidates/:candidate_id",
        component: NewCandidateComponent,
      },
      {
        path: "selection/candidates-synergo",
        component: CandidatesSynergoComponent,
      },
      {
        path: "selection/candidates-synergo/:candidate_id",
        component: NewCandidateSynergoComponent,
      },
      {
        path: "selection/candidate-comments",
        component: CandidateCommentsComponent,
      },
      { path: "selection/educations", component: EducationsComponent },
      {
        path: "selection/work-experiences",
        component: WorkExperiencesComponent,
      },
      { path: "selection/profile-surveis", component: ProfileSurveisComponent },
      {
        path: "selection/profile-surveis/:profile_survey_id",
        component: NewProfileSurveyComponent,
      },

      {
        path: "selection/list-document-profile-surveis",
        component: ListDocumentProfileSurveisComponent,
      },
      {
        path: "selection/document-profile-surveys",
        component: DocumentProfileSurveysComponent,
      },
      { path: "operations/citations", component: CitationsComponent },
      { path: "operations/requisitions", component: RequisitionsComponent },
      {
        path: "operations/profile-surveis",
        component: ProfileSurveisComponent,
      },

      { path: "bank-books/banks", component: BanksComponent },
      { path: "bank-books/bank-books", component: BankBooksComponent },

      { path: "findings", component: FindingsComponent },
      { path: "tips", component: TipsComponent },

      { path: "hire/archives", component: ArchivesComponent },
      { path: "hire/folder-share", component: FolderSharesComponent },
      { path: "hire/citations", component: CitationsComponent },
      { path: "hire/hire-analyst", component: EmployeesComponent },

      {
        path: "digital-documentation/contracts",
        component: ContractsComponent,
      },
      {
        path: "digital-documentation/contracts/:contract_id",
        component: NewContractComponent,
      },
      {
        path: "digital-documentation/expired-documents",
        component: ExpiredDocumentsComponent,
      },

      { path: "service-client/worker-cares", component: WorkerCaresComponent },
      {
        path: "service-client/worker-cares/worker-cares-verification",
        component: WorkerCaresComponent,
      },
      {
        path: "service-client/worker-cares/worker-cares-reported",
        component: WorkerCaresComponent,
      },
      {
        path: "service-client/worker-cares/worker-cares-asigned",
        component: WorkerCaresComponent,
      },

      { path: "service-client/gestionSACs", component: GestionSACsComponent },
      {
        path: "service-client/gestionSACs/:gestion_sac_id",
        component: NewGestionSACComponent,
      },

      {
        path: "service-client/radications-ss",
        component: RadicationsSSComponent,
      },

      {
        path: "synergo/synergo-citations",
        component: SynergoCitationsComponent,
      },
      {
        path: "synergo/synergo-requisitions",
        component: SynergoRequisitionsComponent,
      },
      { path: "**", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pages-routing.module.ts